export const getBaseUrl = () => {
  // Use localhost for local development, production API otherwise
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:5001';
  }
  return 'https://api-6ebu7skxta-uc.a.run.app';
};
